import { Toast } from 'vant';
let textArea;
export function getTextArea () {
    if (textArea) {
        return textArea;
    }
    textArea = document.createElement('textarea');
    textArea.classList.add('x-copy-hidden-textarea')
    document.body.appendChild(textArea);
    return textArea;
}

export function copy (value) {
    let dom = getTextArea();
    dom.value = value;
    dom.select();
    document.execCommand('copy'); // 执行浏览器复制命令
    Toast({
        message: '已复制链接到剪贴板',
        position: 'top'
    })
}